document.addEventListener('change', function(event) {
  if (!event.target.matches('input[type="radio"]')) return;

  var typeInput = document.querySelector('input[type="radio"][value="Wraps"]:checked');

  if (typeInput) {
    document.body.classList.add('camo-type-wraps-selected');
    document.body.classList.remove('camo-type-cones-selected');
  } else {
    document.body.classList.add('camo-type-cones-selected');
    document.body.classList.remove('camo-type-wraps-selected');
  }
});

document.addEventListener('DOMContentLoaded', function() {
  var typeInput = document.querySelector('input[type="radio"][value="Wraps"]:checked');

  if (typeInput) {
    document.body.classList.add('camo-type-wraps-selected');
  } else {
    document.body.classList.add('camo-type-cones-selected');
  }
});
